import script from "./ProjectManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectManager.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectManager.vue?vue&type=style&index=0&id=adbf9538&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adbf9538"]])

export default __exports__